// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"687":"8f4d67d4","2133":"8f4d67d4","9553":"58297519"}[chunkId] + ".chunk.css";
};